export default {
  SET_SCROLL_TO: 'SET_SCROLL_TO',
  SET_SCROLLER_OPTIONS: 'SET_SCROLLER_OPTIONS'
}
